import * as t from "io-ts";
import { BuilderElement } from "@/types/elements";
import { ControlV } from "./controls";

export const ElementStudioItemV = t.type({
  slug: t.string,
  directoryPath: t.string
});

export type ElementStudioItem = t.TypeOf<typeof ElementStudioItemV>;

const SaveLocationTypesV = t.union([
  t.literal("element"),
  t.literal("macro"),
  t.literal("preset")
]);

export type SaveLocationType = t.TypeOf<typeof SaveLocationTypesV>;

export const ElementStudioSaveLocationV = t.type({
  directoryPath: t.string,
  namespace: t.string,
  type: SaveLocationTypesV,
  label: t.string,
  onlyForAdvancedUsers: t.boolean
});

export type ElementStudioSaveLocationWithName = ElementStudioSaveLocation & {
  name: string;
};

export type ElementStudioSaveLocation = t.TypeOf<
  typeof ElementStudioSaveLocationV
>;

export const PresetSectionV = t.type({
  slug: t.string,
  section: ControlV
});

export type PresetSection = t.TypeOf<typeof PresetSectionV>;

export const ElementStudioExpectedDataToLoadV = t.type({
  elements: t.array(ElementStudioItemV),
  macros: t.array(ElementStudioItemV),
  presets: t.array(ElementStudioItemV),
  saveLocations: t.array(ElementStudioSaveLocationV),
  presetSections: t.array(PresetSectionV)
});

export type ElementStudioExpectedDataToLoad = t.TypeOf<
  typeof ElementStudioExpectedDataToLoadV
>;

export type CurrentlyEditingItem = {
  directoryPath: string | false;
  onlyForAdvancedUsers: boolean;
};

export type CurrentlyEditingMacro = CurrentlyEditingItem & {
  macroData: ElementStudioItem & { macro: string };
};

export type CurrentlyEditingPreset = CurrentlyEditingItem & {
  presetData: ElementStudioItem & { preset: PresetSection };
};

export type CurrentlyEditingElement = CurrentlyEditingItem & {
  element: BuilderElement;
};

export type ElementStudioUIMode =
  | "split-vertical"
  | "split-horizontal"
  | "normal";
